import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MonitorIcon, ShoppingCartIcon, PaletteIcon, SearchIcon, ServerIcon, FileTextIcon } from 'lucide-react';
export function IntroSection() {
  const services = [{
    icon: MonitorIcon,
    title: 'Web Design & Development',
    description: 'Fast, mobile-ready websites that rank higher on Google and convert visitors into customers.',
    link: '/services/web-design'
  }, {
    icon: ShoppingCartIcon,
    title: 'E-commerce Websites',
    description: 'Secure online stores built to convert visitors into customers with seamless checkout.',
    link: '/services/ecommerce'
  }, {
    icon: PaletteIcon,
    title: 'Branding & SEO Setup',
    description: 'Professional logos and brand identity combined with SEO optimization to help you stand out.',
    link: '/services/branding'
  }, {
    icon: SearchIcon,
    title: 'SEO Services',
    description: 'Improve your search engine rankings with technical SEO, keyword optimization, and content strategy.',
    link: '/services/seo'
  }, {
    icon: ServerIcon,
    title: 'Website Maintenance',
    description: 'Keep your website secure, updated, and performing at its best with our maintenance plans.',
    link: '/services/maintenance'
  }, {
    icon: FileTextIcon,
    title: 'Content Writing',
    description: 'Professional, engaging content that connects with your audience and drives conversions.',
    link: '/services/content'
  }];
  return <section className="py-12 md:py-16 bg-white dark:bg-primary" data-id="element-309">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-310">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-311">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -4
        }} className="bg-[#212C34] rounded-xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-312">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#0DC3DC]/30 backdrop-blur-sm flex items-center justify-center mb-4 border border-[#0DC3DC]/40" data-id="element-313">
                <service.icon size={28} className="text-[#0DC3DC] md:w-8 md:h-8" data-id="element-314" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-3 text-white" data-id="element-315">
                {service.title}
              </h3>
              <p className="text-white/90 mb-6 leading-relaxed flex-grow text-sm md:text-base" data-id="element-316">
                {service.description}
              </p>
              <Link to={service.link} className="inline-flex items-center text-[#0DC3DC] font-bold hover:text-[#0DC3DC]/80 transition-colors mt-auto text-sm md:text-base" aria-label={`Learn more about ${service.title}`} data-id="element-317">
                Learn More →
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}